import type { FaireProductEntity } from "../../entity_types/product";

export const p_737fzcnwtn: FaireProductEntity = {
  token: "p_737fzcnwtn",
  type: "product",
  name: "Woman's Balance Tincture",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/30184d3c84f1925a53dc362be0b9adce8f7298d03c1d1a2c8879156292c3cd94.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.47,
  description:
    "Experience the power of Nature's Inventory Woman's Balance Tincture. This 1 fl oz potion is crafted to promote a healthy hormone balance. Carefully formulated with a blend of organic grain alcohol, water, and a mix of herbs such as chaste tree, dong quai, red raspberry, dandelion, blessed thistle, gota kola, kelp & licorice. With an alcohol content of 55%, it's strong yet gentle. Our process of hand-bottling ensures that every drop is made with care, keeping you and the environment in mind. Enjoy the balance you deserve.",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:07.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
